var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header center-align"},[_c('div',{staticClass:"header-wrapper"},[_c('a',{staticClass:"center-align",attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}}),_c('span',{staticClass:"logo-text"},[_vm._v("Github Userboard")])])]),(_vm.showSearch)?_c('div',[_c('SearchBox')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }